module.exports = __webpack_public_path__ + "img/health.cdf34d63.svg";